import { useState, useCallback, useEffect } from 'react';
import isMobileDevice from 'common/utils/isMobileDevice';
import { useMediaQuery } from 'common/hooks';
import { useIsActiveGoogleMap } from 'entities/map';

export const useControlsStyles = () => {
  const { mediaQueryRef } = useMediaQuery();
  const isActiveGoogleMap = useIsActiveGoogleMap();
  const [controlsStyles, setControlsStyles] = useState({});

  const getGmnoprintElement = useCallback(() => (
    document.querySelector('.gmnoprint.gm-bundled-control .gm-svpc')
  ), []);

  const getGmnoprintTopPosition = useCallback(() => {
    const element = getGmnoprintElement();
    return element ? element.getBoundingClientRect().top : 0;
  }, [getGmnoprintElement]);

  const onUpdateControslStyles = useCallback(() => {
    const topPosition = getGmnoprintTopPosition();
    const shift = mediaQueryRef.current?.isMobile ? 120 : 90;
    setControlsStyles({
      top: topPosition ? topPosition + shift : '50%'
    });
  }, [setControlsStyles, getGmnoprintTopPosition, mediaQueryRef]);

  useEffect(() => {
    if (isActiveGoogleMap) {
      var observer = new MutationObserver(function(){
        if (getGmnoprintElement() && (getGmnoprintTopPosition() > 50)) {
          onUpdateControslStyles();
          observer.disconnect();
        }
      });

      observer.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }
  // eslint-disable-next-line
  }, [isActiveGoogleMap]);

  useEffect(() => {
    if (isActiveGoogleMap) {
      if (isMobileDevice) {
        window.addEventListener("touchstart", () => {
          onUpdateControslStyles();
        });
        window.addEventListener("touchend", () => {
          onUpdateControslStyles();
        });
      }

      window.addEventListener('resize', () => {
        setTimeout(() => {
          onUpdateControslStyles();
        }, 500);
      });
    }
  // eslint-disable-next-line
  }, [isActiveGoogleMap]);

  return controlsStyles;
};
